import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import React, { useMemo, useEffect, useLayoutEffect, forwardRef, isValidElement, cloneElement } from 'react';
import mergeRefs from 'react-merge-refs';
import { v4 as uuid } from 'uuid';
import { useStyles, StyleSheet, StylesProvider } from '@rexlabs/styling';
import { useOverlay } from './context';
import { memoize } from 'lodash';
var getOverrides = memoize(function (zIndex) {
  return {
    zIndex: {
      base: zIndex
    }
  };
});
var defaultStyles = StyleSheet({
  overlay: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    pointerEvents: 'none'
  },
  show: {
    pointerEvents: 'all'
  }
});
var extendedConfigsDefault = [];
export var Overlay = /*#__PURE__*/forwardRef(function Overlay(_ref, ref) {
  var children = _ref.children,
      style = _ref.style,
      className = _ref.className,
      propId = _ref.id,
      _ref$show = _ref.show,
      show = _ref$show === void 0 ? true : _ref$show,
      _ref$extendedConfigs = _ref.extendedConfigs,
      extendedConfigs = _ref$extendedConfigs === void 0 ? extendedConfigsDefault : _ref$extendedConfigs;
  var s = useStyles(defaultStyles);

  var _useOverlay = useOverlay(),
      overlays = _useOverlay.overlays,
      setShow = _useOverlay.setShow,
      setOverlays = _useOverlay.setOverlays,
      setExtendedConfigs = _useOverlay.setExtendedConfigs;

  var id = useMemo(function () {
    return propId !== null && propId !== void 0 ? propId : uuid();
  }, [propId]);
  useEffect(function () {
    // When this overlay is the one on top we want
    // it to be in control of the backdrop
    if (overlays[overlays.length - 1] === id) {
      setShow(!!show);
      return function () {
        setShow(null);
      };
    }
  }, [id, show, overlays, setShow]);
  useEffect(function () {
    if (overlays[overlays.length - 1] === id) {
      setExtendedConfigs(extendedConfigs);
      return function () {
        setExtendedConfigs(extendedConfigsDefault);
      };
    }
  }, [id, overlays, extendedConfigs, setExtendedConfigs]);
  useLayoutEffect(function () {
    if (show) {
      setOverlays(function (prevOverlays) {
        var _context;

        return _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(prevOverlays), [id]);
      });
      return function () {
        setOverlays(function (prevOverlays) {
          return _filterInstanceProperty(prevOverlays).call(prevOverlays, function (overlay) {
            return overlay !== id;
          });
        });
      };
    }
  }, [id, show, setOverlays]); // Add an extra 1 to our zIndex because we can't be sure
  // that this overlay is rendered further down into the dom
  // than the backdrop is

  var zIndex = (_indexOfInstanceProperty(overlays).call(overlays, id) + 1) * 50 + 1;
  return /*#__PURE__*/React.createElement("div", s.with('overlay', {
    show: show
  })({
    style: style,
    className: className,
    zIndex: zIndex
  }), /*#__PURE__*/React.createElement(StylesProvider, {
    tokens: getOverrides(zIndex)
  }, /*#__PURE__*/isValidElement(children) ?
  /*#__PURE__*/
  // Clone the element and pass the ref down so that
  // if this is within a Transition component then
  // we animate the child of this overlay instead
  cloneElement(children, {
    ref: mergeRefs([ref, children.ref])
  }) : children));
});